// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const asitvColors: ColorType = {
  ...colorPalette,
  grayText: '#B0B0B0',
  grayLabel: '#717171',
  grayBorder: 'rgba(255, 255, 255, 0.38)',
  primary: '#1A9DD9',
  secondary: '#1A9DD9',
}

export const darkTheme = {
  colors: asitvColors,
  background: {
    primary: '#181818',
    secondary: '#262626',
    highlight: asitvColors.dark,
    select: '#2e2e2e',
    footerTop: '#252525',
  },
  text: {
    primary: asitvColors.primaryGray,
    secondary: asitvColors.secondaryGray,
    disabled: asitvColors.grayText,
    link: asitvColors.secondaryGray,
    hint: asitvColors.white,
    highlight: asitvColors.secondary,
    gray: asitvColors.primaryGray,
    seeAll: asitvColors.secondaryGray,
    primaryContrast: '#ffffff',
  },
  border: {
    primary: asitvColors.primaryGray,
    gray: asitvColors.secondaryGray,
  },
  filter: {
    primary: asitvColors.primaryGray,
    secondary: asitvColors.secondaryGray,
    disabled: asitvColors.secondaryGray,
    highlight: '#111111',
  },
  tabs: {
    bg: '#181818',
    containerBg: asitvColors.dark,
    color: asitvColors.white,
    border: asitvColors.primary,
    scrollbarThumb: '#bdbdbd',
    programTitle: asitvColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: '#2e2e2e',
        hover: asitvColors.dark,
        selected: asitvColors.dark,
        progress: rgba(asitvColors.primary, 0.3),
        past: rgba(asitvColors.primary, 0.3),
        pastSelected: asitvColors.dark,
        pastHover: asitvColors.dark,
        empty: '#555555',
        emptyProgress: rgba(asitvColors.primary, 0.2),
      },
      text: {
        empty: asitvColors.secondaryGray,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #181818 0%,${rgba('#181818', 0.97)} 13.03%,${rgba('#181818', 0.69)} 43.24%,${rgba(
          '#181818',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0, #181818 0%,${rgba('#181818', 0.73)} 34.97%,${rgba('#181818', 0)} 100%);`,
    },
  },
  card: {
    title: asitvColors.white,
    subTitle: asitvColors.secondaryGray,
    bg: asitvColors.grayText,
    number: '#DFDFDF',
    boxShadow: '#2e2e2e',
    loaderBackgroundImage: 'linear-gradient(to right, #222 0%, #111 20%, #222 40%, #222 100%)',
  },
  dimension: {
    signLogoSize: 413,
  },
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
